import brandMapping from "./brand-mapping";
import sharedConfig from "./config-shared";
import initiateLoginUriMapping from "./initiate-login-uri-mapping";

const { auth0Domain, auth0PostLoginClientId } = sharedConfig(import.meta.env);

const urlParams = new URLSearchParams(window.location.search);

export const MIN_PASSWORD_LENGTH = 8; // This is also hardcoded into the translation
export const EMAIL_REGEXP = new RegExp(
  "^[a-z0-9._%+-/!#$&'*=?^`{|}~]+@[a-z0-9.-]+\\.[a-z]{2,4}$",
  "i",
);
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

const MOCK_AUTH0_CONFIG =
  "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";

const RAW_AUTH0_CONFIG =
  window.auth0Config === "@@config@@" ? MOCK_AUTH0_CONFIG : window.auth0Config;

export const AUTH0_CONFIG: Auth0Config = JSON.parse(
  decodeURIComponent(escape(window.atob(RAW_AUTH0_CONFIG))),
);

export const DEFAULT_BRAND = "ikon";
export const BRAND =
  import.meta.env.VITE_BRAND ||
  brandMapping[AUTH0_CONFIG.clientID] ||
  brandMapping[urlParams.get("client_id") || ""] ||
  urlParams.get("branding") ||
  DEFAULT_BRAND;

export const DEFAULT_LOCALE = "en";
export const FRENCH_LOCALE = "fr";
export const LOCALE =
  urlParams?.get("ui_locales")?.toLowerCase()?.substring(0, 2) === FRENCH_LOCALE
    ? FRENCH_LOCALE
    : DEFAULT_LOCALE;
export const PASSWORD_RESET_CONFIG = window.passwordResetConfig;
export const INITIATE_LOGIN_URI =
  initiateLoginUriMapping[urlParams.get("client_id") || ""];

export const AUTH0_DATABASE_CONNECTION = "AMP-DB";
export const AUTH0_PASSWORDLESS_CONNECTION = "email";

export const QUERY_PARAMS = Object.fromEntries(urlParams.entries());

// AMP base url
const ampBase = {
  qa: "https://account.qa.ikonpass.com",
  uat: "https://account.uat.ikonpass.com",
  production: "https://account.ikonpass.com",
  default: "http://account.amp.localhost:3000",
}[(import.meta.env.VITE_DEPLOY_TARGET as string) || "default"];

const ampApiBase = {
  qa: "https://api.qa.ikonpass.com",
  uat: "https://api.uat.ikonpass.com",
  production: "https://api.ikonpass.com",
  default: "https://api.qa.ikonpass.com",
}[(import.meta.env.VITE_DEPLOY_TARGET as string) || "default"];

const postLoginBase = {
  qa: "https://qa.guest-profile.alterramtnco.com",
  uat: "https://uat.guest-profile.alterramtnco.com",
  production: "https://guest-profile.alterramtnco.com",
  default: "https://local-app:3000",
}[(import.meta.env.VITE_DEPLOY_TARGET as string) || "default"];

export const POST_LOGIN_POPUP_REDIRECT_URI = `${postLoginBase}/popup_response_handler.html`;

const audience = {
  qa: "https://alterra-qa.us.auth0.com/api/v2/",
  uat: "https://alterra-uat.us.auth0.com/api/v2/",
  production: "https://alterra-production.us.auth0.com/api/v2/",
  default: "https://alterra-qa.us.auth0.com/api/v2/",
}[(import.meta.env.VITE_DEPLOY_TARGET as string) || "default"] as string;

export const AUTH0_POST_LOGIN = {
  clientId: auth0PostLoginClientId || "",
  domain: auth0Domain || "",
  audience,
};

export const AMP_API_CONFIG = {
  baseURL: ampApiBase,
  audience: "alterra-amp-api",
  scope: "guest.read.account api.read.account guest:write",
};

const guestApiBase = {
  qa: "https://guest.qa.alterramtnco.com",
  uat: "https://guest.uat.alterramtnco.com",
  production: "https://guest.alterramtnco.com",
  default: "https://guest.qa.alterramtnco.com",
}[(import.meta.env.VITE_DEPLOY_TARGET as string) || "default"];

export const GUEST_API_CONFIG = {
  audience: "alterra-guest-api",
  scope: "guest:read guest:write",
  baseURL: guestApiBase,
};

export const POST_LOGIN_BASE = postLoginBase;
export const AMP_BASE = ampBase;
export const AUTH0_URL = `https://${auth0Domain}`;
export const LINK_SOCIAL_ACCOUNT_ERROR_URL = `${AMP_BASE}/logout?redirect_uri=${postLoginBase}/index.html?ui_locales=${LOCALE}&brand=${BRAND}#/link-social-account-error`;
const facebookRedirectUri = encodeURIComponent(`${ampBase}/redirect`);
export const FACEBOOK_SIGNUP_URL = `${ampBase}/authorize?redirect_uri=${facebookRedirectUri}&response_type=code&session_type=fb&state=signup&utm_nooverride=1`;

// Routes
export const SIGN_UP_URL = `#/create-account`;
export const FORGOT_PASSWORD_URL = `#/forgot-password`;
export const LOGIN_URL = "#/";

export const MASTER_GUEST_ID_CLAIM =
  "https://login.alterramtnco.com/masterGuestId";
export const POST_LOGIN_CLAIM = "https://login.alterramtnco.com/postLogin";

export const USE_LOCAL_TRANSLATIONS = !!import.meta.env
  .VITE_USE_LOCAL_TRANSLATIONS;

export const USE_BROWSER_ROUTER =
  import.meta.env.VITE_USE_BROWSER_ROUTER === "true" ? true : false;

export const DEPLOY_TARGET = import.meta.env.VITE_DEPLOY_TARGET;

export const TRANSLATION_URL = {
  qa: `https://main--alterra-login-translations.netlify.app/${LOCALE}.json`,
  uat: `https://main--alterra-login-translations.netlify.app/${LOCALE}.json`,
  production: `https://alterra-login-translations.netlify.app/${LOCALE}.json`,
  default: `/translations/${LOCALE}.json`,
}[(import.meta.env.VITE_DEPLOY_TARGET as string) || "default"];

// Datadog RUM
export const DD_RUM_CLIENT_TOKEN =
  import.meta.env.VITE_USE_DD_RUM_CLIENT_TOKEN || "";
export const DD_RUM_APPLICATION_ID =
  import.meta.env.VITE_USE_DD_RUM_APPLICATION_ID || "";
export const DD_RUM_SESSION_REPLAY_SAMPLE_RATE =
  parseInt(import.meta.env.VITE_USE_DD_RUM_SESSION_REPLAY_SAMPLE_RATE || "") ||
  20;
export const DD_RUM_SESSION_SAMPLE_RATE =
  parseInt(import.meta.env.VITE_USE_DD_RUM_SESSION_SAMPLE_RATE || "") || 20;
export const DD_SITE = import.meta.env.VITE_USE_DD_SITE || "us3.datadoghq.com";
export const DD_SERVICE =
  import.meta.env.VITE_USE_DD_SERVICE ||
  `login-${import.meta.env.VITE_DEPLOY_TARGET}`;
export const DD_ENV = import.meta.env.VITE_DEPLOY_TARGET;
export const DD_VERSION = import.meta.env.VITE_GIT_SHA;
export const FLAGS_PATH = {
  qa: "flags.qa",
  uat: "flags.uat",
  production: "flags.production",
  default: "flags.qa",
}[(import.meta.env.VITE_DEPLOY_TARGET as string) || "default"];

export const CLOUDINARY_BASE_URL = {
  qa: "https://res.cloudinary.com/alterra-qa",
  uat: "https://res.cloudinary.com/alterra-uat",
  production: "https://res.cloudinary.com/intrawest",
  default: "https://res.cloudinary.com/intrawest",
}[(import.meta.env.VITE_DEPLOY_TARGET as string) || "default"];
